import { store } from "@/stores/stores"
import { useSnapshot } from "valtio"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Link } from "react-router"
import AvatarUser from "@/components/base/AvatarUser"
import AvatarView from "@/components/base/AvatarView"
import { kinboxUrl } from "@/App"

function UserMenu() {
  const snap = useSnapshot(store)

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="rounded-full">
        <AvatarUser
          name={snap.session.user?.name || ""}
          src={snap.session.user?.avatar || ""}
          className="size-9.5 outline-2 outline-transparent hover:outline-border"
        />
      </DropdownMenuTrigger>
      {/* <DropdownMenuContent className="w-95 p-0"> */}
      <DropdownMenuContent>
        {/* <Link
          to={{
            hash: "#settings/account",
          }}
        >
          <DropdownMenuItem>Settings</DropdownMenuItem>
        </Link> */}
        {/* <DropdownMenuItem>Help & Feedback</DropdownMenuItem> */}
        <DropdownMenuItem
          onClick={() => {
            window.location.href = kinboxUrl
          }}
        >
          Voltar para o Kinbox
        </DropdownMenuItem>
        {/* <DropdownMenuItem onClick={() => store.session.actions.logout()}>Sign Out</DropdownMenuItem> */}
        {/* <div className="fc w-full flex-col gap-2 rounded-t-2xl p-6 shadow">
          <Link to="/settings/account" className="group relative">
            <AvatarView name={snap.session.user?.name || ""} src={snap.session.user?.image || ""} className="size-21" />
          </Link>
          <div className="fc flex-col text-center leading-2">
            <span className="truncate text-xl">Hi, {snap.session.user?.name}!</span>
            <span className="-mt-0.5 truncate text-sm text-fg-secondary">{snap.session.user?.email}</span>
          </div>
        </div>
        <DropdownMenuGroup className="p-2">
          <DropdownMenuItem className="text-md h-11">
            <IconHugeiconsSettings02 className="size-5" />
            Settings
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem className="text-md h-11">
            <IconHugeiconsLogout01 className="size-5" />
            Logout
          </DropdownMenuItem>
        </DropdownMenuGroup> */}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default UserMenu
